import { Component, OnInit,Input,OnChanges,SimpleChanges, Output , EventEmitter} from '@angular/core';

@Component({
  selector: 'selector-grupos',
  template: `
    <select 
      class="select-group" 
      [(ngModel)] ="idReporte" 
      (change)="emitterSelect.emit($event.target.value)">
      <optgroup  
        [style.color]="'#787878'"
        [style.background]="'#ffffff'"
        label="{{opcionGroup.descripcion}}" 
        *ngFor="let opcionGroup of opcionesLista | orderBy:'orden'">
        <option 
          [style.color]="'#343434'" 
          [style.background-color]="'#fff'"
          [value]="opcion.id" 
          *ngFor="let opcion of opcionGroup.children | orderBy:'orden'">
            {{opcion.descripcion}}
        </option>
      </optgroup>
    </select>
  `,
  styles: []
})
export class SelectorGruposComponent implements OnInit, OnChanges {
  @Input() opciones : any
  @Input() agrupar: any
  @Input() idReporte: any
  @Output() emitterSelect  = new EventEmitter()
  opcionesLista: any []

  constructor() { }

  ngOnInit() {
   
  }
  ngOnChanges(changes:SimpleChanges) {
    if(changes.opciones != undefined  && changes.opciones.currentValue != undefined && changes.opciones.currentValue.length > 0){
      let lista = []
      this.agruparOpciones(lista,this.opciones, this.agrupar)
      this.opcionesLista = lista
      console.log("Datos de grupo reportes -->", lista)
   
    }
  }
  private agruparOpciones(lista : any =[], opciones: any, padre: any){
    let hijos = opciones.filter(x=> x.glb_reporte_id == padre)
    if(hijos.length > 0){
      let count = 0 
      for(let hijo of hijos){
        hijo['children'] =[]
        lista[count]= hijo
        this.agruparOpciones(lista[count].children, opciones, hijo.id)
        count ++
      }
    }else{
      return null
    }
  }
  

}



// WEBPACK FOOTER //
// ./src/app/shared/element/selector-grupos.component.ts